import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import auth from "./auth";
import canvas from "./canvas";
import pois from "./pois";
import settings from "./settings";
import helpers from "./helpers";
import filters from "./filters";
import filtered from "./filtered";
import carousel from "./carousel";
import district from "./district";

export default history =>
	combineReducers({
		router: connectRouter(history),
		auth,
		canvas,
		pois,
		settings,
		helpers,
		filters,
		filtered,
		carousel,
		district
	});
